<div class="container">
    <div class="header">
        <h5 class="title">
            {{ 'system-settings.external-communication.title' | translate }}
        </h5>
        <div class="sub-title">
            {{ 'system-settings.external-communication.sub-title' | translate: { num: data.fcuIndex } }}
        </div>
    </div>
    <div class="main">
        <div class="side-menu" (scroll)="scrollSideMenu()">
            <div class="side-menu-item border-bottom">
                <div class="add-button" (click)="addCommunication()" [class.disable]="ceuList?.length >= CEU_MAX_NUM">
                    <mat-icon svgIcon="plus"></mat-icon>
                </div>
            </div>
            <div class="communication-item-list">
                <div
                    class="side-menu-item communication-item"
                    (click)="selectCommunication(externalCommunications)"
                    [class.selected]="isSelectedExternalCommunication(this.selectedCommunication)">
                    {{ 'system-settings.external-communication.default.title' | translate }}
                </div>
                <div
                    class="side-menu-item communication-item"
                    *ngFor="let ceu of ceuList"
                    (click)="selectCommunication(ceu)"
                    (contextmenu)="openContextMenu($event, ceu.index)"
                    [class.contextmenu-open]="isContextMenuOpen && selectedCeuIndexFromContextMenu === ceu.index"
                    [class.selected]="
                        !isSelectedExternalCommunication(this.selectedCommunication) &&
                        selectedCommunication?.index === ceu.index
                    ">
                    {{ 'system-settings.port.ceu-title' | translate: { num: ceu.index } }}
                </div>
            </div>
        </div>
        <div class="content">
            <div class="content-header">
                <h6 class="content-title-external" *ngIf="isSelectedExternalCommunication(selectedCommunication)">
                    {{ 'system-settings.external-communication.default.comm-type' | translate }}
                </h6>
                <div class="content-title-ceu" *ngIf="!isSelectedExternalCommunication(selectedCommunication)">
                    <div class="content-title-input-container">
                        <app-system-setting-dropdown
                            [name]="COMMUNICATION_TYPE"
                            label="system-settings.external-communication.label.select"
                            [itemList]="[SERIAL, LAN]"
                            [value]="selectedCommunication?.commType"
                            [changedBeforeShowDialog]="true"
                            [mainMessage]="changeBeforeDialogMainMessage"
                            [subMessage]="changeBeforeDialogSubMessage"
                            [isDropdownBelow]="true"
                            (onInputChange)="selectInput($event)"
                            (click)="setCommTypeChangeMessage()"
                            class="input-wrapper">
                        </app-system-setting-dropdown>
                        <app-system-setting-input
                            class="ip-input"
                            [name]="FIELD_BUS_LINE_IP"
                            label="system-settings.external-communication.label.field-bus-line-ip"
                            [value]="selectedCommunication?.fieldBusLineIp"
                            (onInputChange)="onInputChange($event)"
                            [inputErrorMessage]="
                                validationErrors[selectedCommunication?.index + FIELD_BUS_LINE_IP]?.message
                            "
                            [showErrorMessage]="true"
                            [maxLength]="15">
                        </app-system-setting-input>
                    </div>
                    <div class="content-options">
                        <div class="content-option" (click)="copyCeu(selectedCommunication)">
                            <mat-icon svgIcon="duplicate"></mat-icon>
                            {{ 'system-settings.external-communication.more-option.copy' | translate }}
                        </div>
                        <div class="content-option" (click)="deleteCeu(selectedCommunication.index)">
                            <mat-icon svgIcon="delete"></mat-icon>
                            {{ 'system-settings.external-communication.more-option.delete' | translate }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="table">
                <div class="row table-header" [class.none-ip]="isCommSerial(selectedCommunication?.commType)">
                    <div class="cell table-header"></div>
                    <div class="cell table-header">
                        {{ 'system-settings.external-communication.table.header.name' | translate }}
                    </div>
                    <div class="cell table-header" *ngIf="!isCommSerial(selectedCommunication?.commType)">
                        {{ 'system-settings.external-communication.table.header.ip-line' | translate }}
                    </div>
                    <div></div>
                </div>
                <div
                    class="row"
                    *ngFor="let port of selectedCommunication?.Ports"
                    [class.none-ip]="isCommSerial(selectedCommunication?.commType)">
                    <div class="cell port-number" [class.disabled]="!port.use">
                        {{ 'Port ' + port.port }}
                    </div>
                    <div class="cell" [class.disabled]="!port.use">
                        {{ port.commName }}
                    </div>
                    <div
                        class="cell"
                        [class.disabled]="!port.use"
                        *ngIf="!isCommSerial(selectedCommunication?.commType)">
                        {{ port.LineIp }}
                    </div>
                    <div
                        class="cell options more-url"
                        (click)="openMoreOption(port); $event.stopImmediatePropagation()">
                        <mat-icon
                            class="more-icon"
                            data-cy="ops-settings-system-setting-fcu-view-fcu-ext-comm-kebab-icon"
                            svgIcon="more-options"></mat-icon>
                        <div class="options-dialog" [class.show]="isOptionOpen && selectedPort?.port === port.port">
                            <div
                                class="options-item"
                                data-cy="ops-settings-system-setting-fcu-view-fcu-ext-comm-hide-port"
                                (click)="hidePort(selectedCommunication?.index, port.port)">
                                {{ 'system-settings.external-communication.more-option.hide-port' | translate }}
                            </div>
                            <div
                                class="options-item"
                                data-cy="ops-settings-system-setting-fcu-view-fcu-ext-comm-edit-port"
                                (click)="editPort()"
                                [class.disabled]="!port.use">
                                {{ 'system-settings.external-communication.more-option.edit' | translate }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer">
        <div class="button-container">
            <button class="text-button" (click)="close()">
                {{ 'dlg.cancel' | translate }}
            </button>
            <app-button
                [disable]="isSaveButtonDisabled()"
                [text]="
                    data.save
                        ? 'system-settings.external-communication.button.save-setting'
                        : 'system-settings.external-communication.button.save'
                "
                customFontFamily="NotoSans-SemiBold"
                size="small"
                customFontSize="14px"
                (onClick)="save()"></app-button>
        </div>
    </div>
</div>

<app-confirmation-window
    #confirmationDialog
    [mainLabel]="mainMessage"
    [subLabel]="subMessage"
    [discardLabel]="'dlg.cancel'"
    [saveLabel]="'dlg.confirm'"
    [allButtonsLeft]="true"
    [inverseColors]="true"></app-confirmation-window>

<div
    class="options-dialog contextmenu"
    [class.show]="isContextMenuOpen"
    [style]="{
        top: contextMenuTop + 'px',
    }">
    <div class="options-item" (click)="deleteCeu(selectedCeuIndexFromContextMenu); $event.stopImmediatePropagation()">
        {{ 'system-settings.external-communication.more-option.delete' | translate }}
    </div>
    <div
        class="options-item"
        (click)="copyCeu(ceuList[selectedCeuIndexFromContextMenu]); $event.stopImmediatePropagation()">
        {{ 'system-settings.external-communication.more-option.copy' | translate }}
    </div>
</div>
